/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ScenicDetail.vue?vue&type=template&id=6a828834&scoped=true&"
import script from "./ScenicDetail.vue?vue&type=script&lang=ts&"
export * from "./ScenicDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ScenicDetail.vue?vue&type=style&index=0&id=6a828834&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a828834",
  null
  
)

export default component.exports